import { useContext } from "react";

import { OrderCreateShippingContext } from "../contexts/OrderCreateShippingContext";

export const useCreateShipmentContext = () => {
  const context = useContext(OrderCreateShippingContext);
  if (context === undefined) {
    throw new Error(
      "useCreateShipmentContext must be within OrderCreateShippingContext",
    );
  }

  return context;
};
